import { ActivityLine, CalculatorInputs, CostLine } from "../types";

export function validActivity(a: ActivityLine): string | null {
  // Solo validar si hay datos significativos (concepto o importe)
  const hasData = a.concept?.trim() || a.baseAmount > 0;
  if (!hasData) return null; // Ignorar líneas completamente vacías

  if (!a.concept?.trim()) return "Falta concepto en un ingreso";
  if (a.baseAmount < 0) return "Un ingreso tiene base negativa";
  return null;
}
export function validCost(c: CostLine): string | null {
  // Solo validar si hay datos significativos (concepto o importe)
  const hasData = c.concept?.trim() || c.baseAmount > 0;
  if (!hasData) return null; // Ignorar líneas completamente vacías

  if (!c.concept?.trim()) return "Falta concepto en un coste";
  if (c.baseAmount < 0) return "Un coste tiene base negativa";
  if ((c.deductiblePct ?? 100) < 0 || (c.deductiblePct ?? 100) > 100) return "% deducible fuera de rango";
  return null;
}

export function validateInputs(i: CalculatorInputs) {
  if (!i.year) throw new Error("Año requerido");
  for (const a of i.activities) {
    const e = validActivity(a); if (e) throw new Error(e);
  }
  for (const c of i.costs) {
    const e = validCost(c); if (e) throw new Error(e);
  }
  if (i.housingAffectationPct < 0 || i.housingAffectationPct > 100) throw new Error("Vivienda afecta debe ser 0..100%");
  if (i.vehicleAffectationPct < 0 || i.vehicleAffectationPct > 100) throw new Error("Vehículo afecta debe ser 0..100%");
  const retaMode = i.profile?.retaActiveMode ?? "full_year";
  if (retaMode === "days") {
    const days = Number(i.profile?.retaActiveDays ?? 0);
    if (!days || days < 1 || days > 365) throw new Error("Introduce un número de días (1–365)");
  }
}
